import { Injectable } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { StripeError } from '@stripe/stripe-js';
import { ApiError } from 'app/interfaces/error.interface';
import firebase from 'firebase';

const DEFAULT_ERROR_KEY = 'NOTSPECIFIED';
const ERROR_KEY_PREFIX = 'ERRORS';

@Injectable({
	providedIn: 'root',
})
export class ErrorService {
	constructor(private translate: TranslateService) {}

	getMessage(
		error: ApiError | firebase.auth.Error | StripeError | string,
		fallbackErrorKey?: string
	): string {
		let toRet: string | null;
		const stripeError: StripeError = error as StripeError;

		if (typeof error === 'string') {
			toRet = this.translate.instant(
				this.attachErrorPrefix([error.toUpperCase()])
			);
		} else if (stripeError && stripeError.type) {
			const key =
				stripeError && stripeError.code && stripeError.code.toUpperCase();
			toRet =
				key && this.translate.instant(this.attachErrorPrefix(['STRIPE', key]));
		} else if ((error as firebase.auth.Error).code) {
			const key = (error as firebase.auth.Error).code.toUpperCase();
			toRet = this.translate.instant(this.attachErrorPrefix(['FIREBASE', key]));
		} else if (error.message && error.message.indexOf('Unknown') > -1) {
			toRet = this.translate.instant(
				this.attachErrorPrefix(['FIREBASE', 'AUTH/WRONG-PASSWORD'])
			);
		} else if ((error as ApiError).messageI18n) {
			this.applyDataKeys(error as ApiError);
			toRet = (error as ApiError).messageI18n;
		}

		if (!toRet && fallbackErrorKey) {
			toRet = this.translate.instant(
				this.attachErrorPrefix([fallbackErrorKey.toUpperCase()])
			);
		}

		if (!toRet) {
			return this.getDefaultError();
		}
		return toRet;
	}

	getDefaultError(): string {
		return this.translate.instant(this.attachErrorPrefix([DEFAULT_ERROR_KEY]));
	}

	private attachErrorPrefix(key: string[]): string {
		return `${ERROR_KEY_PREFIX}.${key.join('.')}`;
	}

	private applyDataKeys(error: ApiError) {
		if (error.data) {
			const contextK = Object.keys(error.data);
			for (const k of contextK) {
				if (error.messageI18n.includes(`{{${k}}}`)) {
					if (Array.isArray(error.data[k])) {
						error.messageI18n = error.messageI18n.replace(
							`{{${k}}}`,
							error.data[k].join(',')
						);
					} else {
						error.messageI18n = error.messageI18n.replace(
							`{{${k}}}`,
							error.data[k]
						);
					}
				}
			}
		}
	}
}
